import { lazy } from "react"
import { OysterRouter } from "~/router/type"
import { PermissionProtectedRoute } from "~/router/outlets/PermissionProtectedRoute"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"

const EquityGrantPage = lazy(() => import("./pages/CompanyEquityGrantFormPage/EquityGrantPage"))
const EquityCompanyPlanOverviewPage = lazy(
  () => import("./pages/CompanyEquityPlanPage/EquityCompanyPlanOverviewPage"),
)
const EquityWithholdingFormPage = lazy(
  () => import("./pages/CompanyEquityWithholdingFormPage/EquityWithholdingFormPage"),
)
const EquityGrantsCompanyPage = lazy(() => import("./pages/CompanyEquityGrantsPage"))
const CompanyEquityWithholdingsPage = lazy(() => import("./pages/CompanyEquityWithholdingsPage"))
const CompanyEquityFormPage = lazy(() => import("./pages/CompanyEquityPlanFormPage"))
const CompanyValuationFormPage = lazy(() => import("./pages/CompanyEquityValuationFormPage"))
const CompanyEquityTaxCalculatorPage = lazy(
  () => import("./pages/EquityTaxCalculatorPage/CompanyEquityTaxCalculator"),
)

export const companyEquityRoutes: OysterRouter = {
  DeprecatedLeftSidebar: [
    {
      element: <PermissionProtectedRoute permissions={["equity_overview"]} />,
      children: [
        {
          path: "equity/overview",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <EquityCompanyPlanOverviewPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "equity/new",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <CompanyEquityFormPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "equity/edit",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <CompanyEquityFormPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "valuation/new",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <CompanyValuationFormPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
      ],
    },
    {
      element: <PermissionProtectedRoute permissions={["equity_compensation"]} />,
      children: [
        {
          path: "equity/grants",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <EquityGrantsCompanyPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "equity/grant/new",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <EquityGrantPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "equity/grant/:equityGrantStrongId",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <EquityGrantPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
      ],
    },
    {
      element: <PermissionProtectedRoute permissions={["equity_withholding"]} />,
      children: [
        {
          path: "equity/events",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <CompanyEquityWithholdingsPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "equity/events/new",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <EquityWithholdingFormPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "equity/events/:withholdingStrongId",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <EquityWithholdingFormPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
      ],
    },
    {
      path: "equity/tax-calculator",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <CompanyEquityTaxCalculatorPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
  ],
}
